<template>
    <el-dialog
            visible
            width="55%"
            @close="onCancel">
            <div slot="title">
                <span class="font18">{{ initData.id? $t('COMMON_EDIT') : $t('COMMON_ADD') }}</span>
            </div>
            <el-row class="mb-15">
                <el-col :span="7"><i class="required-cls">*</i>{{ $t('admin.entityName') }}</el-col>
                <el-col :span="15">
                    <el-input  v-model="entityName" />
                </el-col>
            </el-row>
            <el-row class="mb-15">
                <el-col :span="7"><i class="required-cls">*</i>{{ $t('admin.signingDate') }}</el-col>
                <el-col :span="15">
                    <el-date-picker
                            v-model="signingDate"
                            class="w-full"
                            type="date"
                            value-format="yyyy-MM-dd"
                        >
                        </el-date-picker>
                </el-col>
            </el-row>
            <el-row class="mb-15" v-if="this.type === 'contract'">
                <el-col :span="7"><i class="required-cls">*</i>{{ $t('admin.contractType') }}</el-col>
                <el-col :span="15">
                    <el-select v-model="contractType"  :placeholder="$t('admin.contractType')" class="w-full">
                            <el-option v-for="(v, k) in categoryOptions" :key="k" :label="v.label" :value="v.value"></el-option>
                    </el-select>
                </el-col>
            </el-row>
            <span slot="footer" class="dialog-footer">
                <el-button @click="onCancel"
                           class="cancel-btn">{{$t('comment_reSet')}}</el-button>
                <el-button type="primary"
                           :loading="saveLoading"
                           @click="onConfirm"
                           class="wl-green">{{$t('btn_save')}}</el-button>
          </span>
    </el-dialog>
</template>

<script>
    import API from "@/api";
    import {mapGetters} from "vuex";
    
    export default {
        name: "AdminAdd",
        props: {
            saveLoading: {
                type: Boolean,
                default: false
            },
            initData: {
                type: Object,
                default: {}
            },
            onCancel: {
                type: Function,
                default: () => {}
            },
            onAdd: {
                type: Function,
                default: () => {}
            },
            type: {
                type: String,
                default:null
            },
            categoryOptions:{
                type: Array,
                default:[]
            }
        },
        computed: {
            ...mapGetters('common', {
                getUser: 'getUser',
                getSite: 'getSite',
            }),
        },
        watch: {
            
        },
        data(){
            return {
                // contractTypeOptions,
                entityName:'',
                signingDate:null,
                contractType:null,
            }
        },
      
        mounted() {
        const {entityName,signingDate,contractType} = this.initData
          this.entityName = entityName
          this.signingDate = signingDate
          if(contractType) {
            this.contractType = contractType;
          }
        },
        methods: {
            onConfirm() {
                if(!this.entityName){
                    this.$message.error(this.$t('admin.enterTip',{name:this.$t('admin.entityName')}))

                } else if(!this.signingDate){
                    this.$message.error(this.$t('admin.selTip',{name:this.$t('admin.signingDate')}))

                }else if(!this.contractType&&this.type === 'contract'){
                    this.$message.error(this.$t('admin.selTip',{name:this.$t('admin.contractType')}))

                } else {
                    let temp = Object.assign({}, this.initData)
                    temp.entityName = this.entityName
                    temp.signingDate = this.signingDate
                    temp.contractType = this.contractType
                    this.onAdd(temp)
                }

            },
        }
    }
</script>

<style scoped>
    .font18{
        font-size: 18px;
    }
    .select-width{
        width: 100%;
    }
    .entity-list-tree-node {
        width: 100%;
        display: flex;
        justify-content: space-between;
    }
    .entity-list-tree-node .extra-area {
        margin-right: 5px;
        color: #409eff;
        align-self: center;
    }
    .entity-list-tree-node .extra-area:hover {
        margin-right: 5px;
        color: #409eff;
    }
    .required-cls{
        color:#fd349c;
        font-size: 14px;
        margin-right: 5px;
    }
    .tree {
        margin-top: 10px;
        height: 250px;
        overflow-y: auto;
    }
</style>